
export const SET_LOCATION="SET_LOCATION"
export const SET_SESSIONTYPE="SET_SESSIONTYPE"
export const SET_CENTRE="SET_CENTRE"

